import { orderBy } from 'lodash'

type returnValue = {
  value: MData.Project['_id']
  label: string
  isHidden: boolean
  subLabel: JSX.Element
  alt: string
  isDisabled: boolean
}

type getProjectsForMultiselectOptionsType = {
  ignoreReportsToForProjects: boolean
  permission: boolean
  connectedUser: string | undefined
  t: (key: string) => string
}

export const getProjectsForMultiselect = (
  projects: Pick<MData.Project, '_id' | 'code' | 'name' | 'projectOwners' | 'status'>[],
  { ignoreReportsToForProjects, permission, connectedUser, t }: getProjectsForMultiselectOptionsType
): returnValue[] => {
  const sortedProjects = orderBy(projects, [project => project.status === 'ARCHIVED', 'name'])

  return sortedProjects.map(({ _id: value, name: label, code, projectOwners = [], status }) => {
    const canAssignProject = ignoreReportsToForProjects || !permission || (connectedUser && projectOwners.map(({ _id }) => _id).includes(connectedUser))
    const isProjectArchived = status === 'ARCHIVED'
    return {
      label,
      value,
      isHidden: !canAssignProject,
      subLabel: (
        <small className="text-muted">
          <span className="mr-1">[{code}]</span>
          {isProjectArchived ? <span>{t(`manager.projects.STATUSES.ARCHIVED`)}</span> : null}
        </small>
      ),
      alt: code,
      isDisabled: isProjectArchived
    }
  })
}
